import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import styles from './index.styles';
import QRCode from 'qrcode.react';
import noimg from './images/noimg.png'
import { Box, Grid, Typography } from "@mui/material";
import LOCATION_TYPE from '../enum/location_type';
import BOX_TYPES from '../enum/box_type';
import CONNECTION_TYPE from '../common/connection-type';
import PropTypes from 'prop-types';
const { getParams } = require('./common/helpers.fn');
export class LabelTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { classes, rxNumbers, t, boxDetails, boxId, connectionType,accountConnectionsId,rxEntries } = this.props;
    const pharmacyPictureUrl = this.props && this.props.pharmacyDetails && this.props.pharmacyDetails.picture_url;
    const pharmacyDetails = this.props && this.props.pharmacyDetails;
    const accountdetails = this.props && this.props.accountDetails;
    const firstname = this.props && this.props.firstName;
    const brandingName = this.props && this.props.brandingName;
    const brandPhoneNumber = this.props && this.props.brandingPhone;
    const lastname = this.props && this.props.lastName;
    const dateOfBirth = this.props && this.props.dateOfBirth;
    const isCoolItem = this.props && this.props.isCoolItem;
    const locationTypeID = this.props && this.props.locationTypeID;
    // const prefer_location_name = this.props && this.props.prefer_location_name;
    let location = {
      picture_url: '',
      name: '',
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    };
    // Use robust ID comparison - boxId may be string, ids in boxDetails may vary
    const boxIdStr = boxId != null ? String(boxId) : '';
    let _boxDetails = boxDetails && boxDetails.find((x) => x && String(x.id) === boxIdStr);
    // Authoritative branding: use boxDetails lookup by boxId - parent state (brandingName/brandingPhone) can be stale when location pre-selected or switched
    const _bdName = _boxDetails && _boxDetails.brandName;
    const resolvedBrandName = (_bdName != null ? _bdName : brandingName) || '';
    const _bdPhone = _boxDetails && _boxDetails.brandPhone;
    const resolvedBrandPhone = (_bdPhone != null ? _bdPhone : brandPhoneNumber) || '';
    const compactStockLabelLayout = this.props && this.props.compactStockLabelLayout;
    if (connectionType === 0) {
      if (_boxDetails) {
        location.picture_url = _boxDetails.picture_url;
        location.name = _boxDetails.name;
        location.address_line_1 = _boxDetails.address_line_1;
        location.address_line_2 = _boxDetails.address_line_2;
        location.city = _boxDetails.city;
        location.state = _boxDetails.state;
        location.country = _boxDetails.country;
        location.zip = _boxDetails.zip;
      }
    } else {
      if (_boxDetails) {
        // Support both nested (GET /boxes) and flattened (getBoxesById) address structure
        const addr = _boxDetails.address || _boxDetails;
        location.picture_url = _boxDetails.picture_url;
        location.name = _boxDetails.name;
        location.address_line_1 = addr.address_line_1;
        location.address_line_2 = addr.address_line_2;
        location.city = addr.city;
        location.state = addr.state;
        location.country = addr.country;
        location.zip = addr.zip;
      }
    }

    // Compact-label fallback: Counter flow may provide location details via `pharmacyDetails`
    // instead of an array `boxDetails` used by `_boxDetails` lookup.
    if (
      compactStockLabelLayout &&
      pharmacyDetails &&
      !Array.isArray(pharmacyDetails) &&
      ['', null, 'null', undefined, 'undefined'].includes(location.name) &&
      ['', null, 'null', undefined, 'undefined'].includes(location.address_line_1)
    ) {
      const addr =
        pharmacyDetails.address && typeof pharmacyDetails.address === 'object'
          ? pharmacyDetails.address
          : pharmacyDetails;
      const isBlank = (value) => ['', null, 'null', undefined, 'undefined'].includes(value);
      const pickFirst = (...values) => values.find((v) => !isBlank(v));

      if (isBlank(location.picture_url)) location.picture_url = pickFirst(pharmacyDetails.picture_url, addr.picture_url, '') || '';
      if (isBlank(location.name)) location.name = pickFirst(pharmacyDetails.name, addr.name, '') || '';
      if (isBlank(location.address_line_1)) location.address_line_1 = pickFirst(addr.address_line_1, addr.address1, '') || '';
      if (isBlank(location.address_line_2)) location.address_line_2 = pickFirst(addr.address_line_2, addr.address2, '') || '';
      if (isBlank(location.city)) location.city = pickFirst(addr.city, '') || '';
      if (isBlank(location.state)) location.state = pickFirst(addr.state, '') || '';
      if (isBlank(location.country)) location.country = pickFirst(addr.country, '') || '';
      if (isBlank(location.zip)) location.zip = pickFirst(addr.zip, addr.pincode, '') || '';
    }
    // Get codes from props ONLY - NO localStorage
    const codes = {
      stockCode: this.props.stockCode || '',
      pickupCode: this.props.pickupCode || ''
    };
    
    // Validate required data
    if (!codes.stockCode) {
      console.error('LabelTemplate: stockCode is required but not provided');
      return (
        <Box component="div" className={classes.boxDesign}>
          <Typography color="error">Error: Missing stock code</Typography>
        </Box>
      );
    }

    const isEmptyValue = (value) => ['', null, 'null', undefined, 'undefined'].includes(value);
    const formatLocationLine = (...parts) => parts.filter((part) => !isEmptyValue(part)).join('');
    const locationName = isEmptyValue(location.name) ? '' : location.name;
    const locationLine1 = formatLocationLine(
      isEmptyValue(location.address_line_1) ? '' : `${location.address_line_1},`,
      isEmptyValue(location.address_line_2) ? '' : location.address_line_2
    );
    const locationLine2 = formatLocationLine(
      isEmptyValue(location.city) ? '' : `${location.city},`,
      isEmptyValue(location.state) ? '' : location.state,
      isEmptyValue(location.country) ? '' : `${location.country}-`,
      isEmptyValue(location.zip) ? '' : location.zip
    );
    const rxNumberList = accountConnectionsId === CONNECTION_TYPE.BASIC
      ? (rxEntries || []).map((entry) => entry && entry.rxNumber).filter(Boolean)
      : (rxNumbers || []).filter(Boolean);
    const compactSupportMessage = resolvedBrandPhone
      ? `Questions? To speak with a pharmacist call ${resolvedBrandPhone}.`
      : 'Questions? To speak with a pharmacist.';
    const showFastlanePosition = _boxDetails && _boxDetails.type_id && _boxDetails.type_id === BOX_TYPES.FASTLANE;

    const getBinPosition = () => {
      const { bin_id } = this.props;
      
      // Validate bin_id is provided - NO localStorage fallback
      if ([undefined, 'undefined', null, 'null', ''].includes(bin_id)) {
        console.error('LabelTemplate: bin_id is required but not provided');
        return 'ERROR: NO BIN';
      }
      
      const _binId = bin_id;
      const _getBinPosition = getParams(_binId);
      const columnNumber = _getBinPosition.columnNumber.toString().length <= 1 ? `0${_getBinPosition.columnNumber}` : _getBinPosition.columnNumber;
      const RowNumber = _getBinPosition.rowNumber.toString().length <= 1 ? `0${_getBinPosition.rowNumber}` : _getBinPosition.rowNumber;
      return `${_getBinPosition.direction}-C${columnNumber}-R${RowNumber} #${_binId}`
    }

    return (
      <Box component="div" id="printableArea" className={classes.boxDesign}>
        {accountdetails &&
          <Box component="div" className={classes.boxcontainer}>
            <Box component="div" className={classes.boxLogo}>
              {location && (
                <Box
                  component="img"
                  alt="logo"
                  height="30px"
                  width="40px"
                  src={
                    [' ', '', null, 'null', undefined, 'undefined'].includes(location.picture_url)
                      ? ([' ', '', null, 'null', undefined, 'undefined'].includes(pharmacyPictureUrl) ? noimg : pharmacyPictureUrl)
                      : location.picture_url
                  }
                />
              )}
            </Box>
            <Box component="div" className={classes.spacer}></Box>
            <Box component="div" className={classes.boxLogoDesc}>
              {['', null, 'null', undefined, 'undefined'].includes(accountdetails.name) ? '' : accountdetails.name}<br />
            </Box>
          </Box>
        }
        {!compactStockLabelLayout && location &&
          <Box component="div" className={classes.deliveryContainer}>
            {t("Label.DeliverTo")}:<br />
            {locationName}<br />
            {locationLine1}<br />
            {locationLine2}
          </Box>
        }
        <Box component="div" className={classes.prescriptionContainer}>
          {compactStockLabelLayout ? (
            <React.Fragment>
              <Grid container sx={{ mb: '5px' }}>
                <Grid item xs={12}>
                  <Box component="div" sx={{ fontWeight: '400', fontSize: '0.8rem' }}>
                    {compactSupportMessage}
                  </Box>
                </Grid>
              </Grid>
              <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
              <Grid container sx={{ mt: '5px', mb: '5px' }}>
                <Grid item xs={7}>
                  <Box component="div" className={classes.qrcodeContainer}>
                    {codes && codes.stockCode ? <Typography><QRCode height="70px" width="70px" includeMargin={false} renderAs={'svg'} value={codes && codes.stockCode} /></Typography> : ""}
                  </Box>
                  <Box component="h3" sx={{ textAlign: 'left', mb: '4px', mt: '4px' }}>{codes && codes.stockCode}</Box>
                </Grid>
                <Grid item xs={5} sx={{ textAlign: 'left', lineHeight: '14px', pl: '4px' }}>
                  {rxNumberList.map((rxNumber, index) => (
                    <Box component="div" key={index}>
                      {rxNumber && rxNumber.toString().toUpperCase()}
                    </Box>
                  ))}
                </Grid>
              </Grid>
              <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
              {showFastlanePosition ? (
                <div>
                  <Grid container sx={{ mt: '5px', mb: '5px' }}>
                    <Grid item xs={12}>
                      Bin Position
                    </Grid>
                    <Grid item xs={12}>
                      {getBinPosition()}
                    </Grid>
                  </Grid>
                  <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
                </div>
              ) : null}
              <Grid container sx={{ mt: '5px', mb: '5px' }}>
                <Grid item xs={12}>
                  {firstname}{' '}{lastname}<br />
                </Grid>
                <Grid item xs={12}>
                  {[LOCATION_TYPE.Kiosk].includes(locationTypeID) === true ?
                    isCoolItem ? 'REFRIGERATED' : ''
                    : ''
                  }
                </Grid>
              </Grid>
              <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
              {location &&
                <Box component="div" className={classes.deliveryContainer} sx={{ borderBottom: 'none', paddingBottom: 0 }}>
                  {t("Label.DeliverTo")}:<br />
                  {locationName}<br />
                  {locationLine1}<br />
                  {locationLine2}
                </Box>
              }
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Grid container>
                <Grid item xs={12}>
                  <Box component="div" className={classes.qrcodeContainer}>
                    {codes && codes.stockCode ? <Typography><QRCode height="70px" width="70px" includeMargin={false} renderAs={'svg'} value={codes && codes.stockCode} /></Typography> : ""}                
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <Box component="h3" sx={{ textAlign: 'left', mb: '4px' }}>{codes && codes.stockCode}</Box>
                </Grid>
              </Grid>
              <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
              {showFastlanePosition ? (
                <div>
                  <Grid container sx={{ mt: '5px', mb: '5px' }}>
                    <Grid item xs={12}>
                      Bin Position
                    </Grid>
                    <Grid item xs={12}>
                      {getBinPosition()}
                    </Grid>
                  </Grid>
                  <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
                </div>
              ) : null}
              <Grid container sx={{ mt: '5px', mb: '5px' }}>
                <Grid item xs={12}>
                  {firstname}{' '}{lastname}<br />
                </Grid>
                <Grid item xs={12}>
                  {dateOfBirth}
                </Grid>
                <Grid item xs={12}>
                  {[LOCATION_TYPE.Kiosk].includes(locationTypeID) === true ?
                    isCoolItem ? 'REFRIGERATED' : ''
                    : ''
                  }
                </Grid>
              </Grid>
              <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
              <Grid container sx={{ mt: '5px', mb: '5px' }}>
                <Grid item xs={12}>
                  {t("Label.Count")} ({rxNumberList.length})<br />
                  {rxNumberList.map((rxNumber, index) => (
                    <Box component="div" key={index}>
                      {rxNumber && rxNumber.toString().toUpperCase()}
                    </Box>
                  ))}
                </Grid>
              </Grid>
              <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
              <Grid container sx={{ mt: '5px' }}>
                <Grid item xs={12}>
                  <Box component="div" sx={{ fontWeight: '400', fontSize: '0.8rem' }}>
                    {resolvedBrandName && resolvedBrandPhone
                      ? `${t("Label.SecMessage")} ${resolvedBrandName} at ${resolvedBrandPhone}`
                      : resolvedBrandPhone
                        ? `${t("Label.SecMessage")}${resolvedBrandName ? ` ${resolvedBrandName} at ` : ' '}${resolvedBrandPhone}`
                        : resolvedBrandName
                          ? `${t("Label.SecMessage")} ${resolvedBrandName}`
                          : t("Label.SecMessage")}
                  </Box>
                </Grid>
              </Grid>
            </React.Fragment>
          )}
        </Box>
      </Box>
    );
  }
}

// PropTypes validation
LabelTemplate.propTypes = {
  // Required props
  stockCode: PropTypes.string.isRequired,
  pickupCode: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  dateOfBirth: PropTypes.string.isRequired,
  bin_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  
  // Optional props
  rxNumbers: PropTypes.array,
  rxEntries: PropTypes.array,
  isCoolItem: PropTypes.bool,
  locationTypeID: PropTypes.number,
  brandingName: PropTypes.string,
  brandingPhone: PropTypes.string,
  accountDetails: PropTypes.object,
  boxDetails: PropTypes.array,
  boxId: PropTypes.number,
  connectionType: PropTypes.number,
  accountConnectionsId: PropTypes.number,
  compactStockLabelLayout: PropTypes.bool,
  t: PropTypes.func.isRequired
};

LabelTemplate.defaultProps = {
  rxNumbers: [],
  rxEntries: [],
  isCoolItem: false,
  locationTypeID: null,
  brandingName: '',
  brandingPhone: '',
  connectionType: 0,
  compactStockLabelLayout: false
};

export default withStyles(styles)(LabelTemplate);



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/labelTemplate.js